module.exports = __webpack_public_path__ + "static/media/choose-games.3496d7fb.png";